import {connect} from 'react-redux';
import ModalContactSupport from './ModalContactSupport';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {showGlobalErrorMessage}
)(ModalContactSupport);
